export default {
    name: 'rb',
    serverName: '​/api​/v1​/rb_calculator​/calculation​/',
    apiUrl: '/api/v1/rb_calculator/calculation/'
};
